// extracted by mini-css-extract-plugin
export default {"FiltroWrapper":"styles_FiltroWrapper__bpz6-"};